import { Controller, Control, FieldValues, FieldPath } from "react-hook-form";
import Select, { SelectProps } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

export interface OptionType {
  value: string | number;
  label: string;
}

interface FormMuiSelectProps<T extends FieldValues> extends Omit<SelectProps, "name"> {
  name: FieldPath<T>;
  control: Control<T>;
  options: OptionType[];
  label?: string;
  numberValue?: boolean; // If true, converts value to number onChange
}

export function FormMuiSelect<T extends FieldValues = any>({
  name,
  control,
  options,
  label,
  numberValue = false,
  ...selectProps
}: FormMuiSelectProps<T>) {
  return (
    <FormControl fullWidth size={selectProps.size || "small"}>
      {label && <InputLabel>{label}</InputLabel>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            label={label}
            value={field.value ?? ""}
            onChange={e => {
              const value = e.target.value;
              field.onChange(numberValue ? Number(value) : value);
            }}
            displayEmpty
            {...selectProps}
          >
            <MenuItem value="" disabled>
              {label || "Chọn tham số"}
            </MenuItem>
            {options.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
}

export default FormMuiSelect;
